import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'best-practices',
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class BestPracticesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
